import { render, staticRenderFns } from "./InitialScreen.vue?vue&type=template&id=bf96ff52&scoped=true&"
import script from "./InitialScreen.vue?vue&type=script&lang=js&"
export * from "./InitialScreen.vue?vue&type=script&lang=js&"
import style0 from "./InitialScreen.vue?vue&type=style&index=0&id=bf96ff52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf96ff52",
  null
  
)

export default component.exports